import { completeCallReviewDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const completeCallReviewCallable = getCallable(
  completeCallReviewDefinition,
);
